export const errorCode = {
  ttsDisabled: 695,
  roleNameAlreadyExists: 651,
  emailAllReadyExist: 605,
  InternalServerError: 'InternalServerError',
  ZodError: 'ZodError',
  ZerobounceInvalidEmailError: 'ZerobounceInvalidEmailError',
  ZerobounceCorporationEmailError: 'ZerobounceCorporationEmailError',
  PlaceSuspended: 'PlaceSuspended',
  UserSuspended: 'UserSuspended',
  UnauthorizedError: 'UnauthorizedError',
  SystemMaintenanceError: 'SystemMaintenanceError',
}
